document.documentElement.classList.remove('no-js');

const EP = {
  root: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/',
  openDrawer() { document.body.classList.add('drawer-open'); },
  closeDrawer() { document.body.classList.remove('drawer-open'); },
  async refreshDrawer(open = true) {
    try {
      const res = await fetch(`${this.root}?section_id=cart-drawer`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer-wrap]');
      const current = document.querySelector('[data-cart-drawer-wrap]');
      if (fresh && current) current.replaceWith(fresh);
      const cart = await fetch(`${this.root}cart.js`).then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      if (open) this.openDrawer();
    } catch(e) { window.location.href = `${this.root}cart`; }
  }
};
window.EPTheme = EP;

document.addEventListener('click', (event) => {
  const menuToggle = event.target.closest('[data-menu-toggle]');
  if (menuToggle) {
    const nav = document.querySelector('[data-mobile-nav]');
    if (nav) {
      const open = nav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('menu-open', open);
    }
    return;
  }
  if (event.target.closest('[data-cart-open]')) { EP.openDrawer(); return; }
  if (event.target.closest('[data-cart-close]') || event.target.matches('[data-drawer-backdrop]')) { EP.closeDrawer(); return; }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-product-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const root = select.closest('[data-product-root]');
  const priceTarget = root?.querySelector('[data-product-price]');
  const compareTarget = root?.querySelector('[data-compare-price]');
  const button = root?.querySelector('[data-add-button]');
  if (priceTarget && option.dataset.price) priceTarget.textContent = option.dataset.price;
  if (compareTarget) {
    compareTarget.textContent = option.dataset.compare || '';
    compareTarget.hidden = !option.dataset.compare;
  }
  if (button) {
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? 'ADD TO BAG' : 'SOLD OUT';
  }
  if (option.value && window.history.replaceState) {
    const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form.product-form, form.product-card-form');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('[data-add-button]');
  const original = button?.textContent;
  if (button) { button.disabled = true; button.textContent = 'ADDING…'; }
  try {
    const res = await fetch(`${EP.root}cart/add.js`, {method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form)});
    if (!res.ok) throw new Error('Add to cart failed');
    await res.json();
    await EP.refreshDrawer(true);
  } catch(e) {
    form.submit();
  } finally {
    if (button) { button.disabled = false; button.textContent = original || 'ADD TO BAG'; }
  }
});
